import * as React from "react";
import Svg, { Path } from "react-native-svg";

const SelectIcon = (props) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2ZM8 16V4h12l.002 12H8Z"
      fill={props.color}
    />
    <Path
      d="M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8Zm8.933 3.519-1.726-1.726-1.414 1.414 3.274 3.274 5.702-6.84-1.538-1.282-4.298 5.16Z"
      fill={props.color}
    />
  </Svg>
);

SelectIcon.defaultProps = {
  color: "#A7A7A7",
};
export default SelectIcon;
